module.exports = __webpack_public_path__ + "static/zikto_profile@2x-6817f6c94e000a119597a3408871db3e.png";